import { render } from "./AdminFaqTable.vue?vue&type=template&id=1ddcf842"
import script from "./AdminFaqTable.vue?vue&type=script&lang=js"
export * from "./AdminFaqTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__